/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ firstName: NonNullable<unknown> }} Notifications_Email_GreetingInputs */

const he_notifications_email_greeting = /** @type {(inputs: Notifications_Email_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`שלום ${i?.firstName},`)
};

const en_notifications_email_greeting = /** @type {(inputs: Notifications_Email_GreetingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hi ${i?.firstName},`)
};

/**
* | output |
* | --- |
* | "Hi {firstName}," |
*
* @param {Notifications_Email_GreetingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_email_greeting = /** @type {((inputs: Notifications_Email_GreetingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Email_GreetingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_email_greeting(inputs)
	return en_notifications_email_greeting(inputs)
});